import { MediaPlayer } from '@dixa/lib-shared-habla';
import { useAuthData } from 'lib-shared-auth';
import { ComponentProps } from 'react';

import { isPrivateFilesAPI } from 'utils/api';

type MediaPlayerProps = ComponentProps<typeof MediaPlayer>;

type PrivatMediaPlayerProps = Omit<
  MediaPlayerProps,
  'isPrivateFile' | 'headers'
>;

export const PrivateMediaPlayer = ({
  ...props
}: PrivatMediaPlayerProps): JSX.Element => {
  const authData = useAuthData();
  const hashToken = btoa(`token:${authData?.access_token}`);
  const headers: Record<string, string> = authData
    ? {
        Authorization: `Basic ${hashToken}`,
      }
    : {};

  const isPrivateFile = isPrivateFilesAPI(props.mediaFile.src || '');

  if (isPrivateFile && !authData) {
    return <></>;
  }

  return (
    <MediaPlayer {...props} isPrivateFile={isPrivateFile} headers={headers} />
  );
};
